import React, {useEffect, useState} from 'react';
import './business.scss';
import {BusinessAccordion, Button, Loading} from 'components';
import AddBusiness from './add-business/AddBusiness';
import BUSINESS_EMPTY_IMAGE from 'assets/icons/business_empty_image.png';
import {BusinessPanel} from "../../../components/business-accordion/BusinessAccordion";
import {useGetBusinessByUser} from "../../../operations/queries/useGetBusinessByUser";
import {useSession} from "providers/UseSession";

export const Business = () => {
    const [businessData, setBusinessData] = useState<BusinessPanel[]>([]);

    const {payload} = useSession();
    const [business, setBusiness] = useState<Array<{ component: any }>>([]);

    const [isAddBusiness, setIsAddBusiness] = useState(false);

    const {data, isLoading} = useGetBusinessByUser({member_id: payload.id})


    useEffect(() => {
        setBusinessData([]);
        if (data?.length > 0) {
            console.log(data)
            data?.map((incomingBusiness: any) =>
                (
                    setBusinessData((prev: BusinessPanel[]) => ([
                            ...prev.filter((prevBusiness) => prevBusiness.business.id !== incomingBusiness.business),
                            {
                                id: prev.length + 1,
                                business: {
                                    id: incomingBusiness.id,
                                    // is_approved: incomingBusiness.is_approved === "1" ?
                                    //     parseInt(incomingBusiness.is_approved) : incomingBusiness.is_approved,
                                    is_approved: incomingBusiness.is_approved,
                                    member_id: incomingBusiness.member_id,
                                    date_approved: incomingBusiness.date_approved,
                                    membership_level: incomingBusiness.membership_level,
                                    details: incomingBusiness.details,
                                    information: incomingBusiness.information,
                                    category: incomingBusiness?.category,
                                    products_services: incomingBusiness.products_services,
                                    required_assistance: incomingBusiness.required_assistance,
                                    expectation_of_sbaj: incomingBusiness.expectation_of_sbaj,
                                    other_information: incomingBusiness.expectation_of_sbaj,
                                    payment: incomingBusiness.expectation_of_sbaj,
                                }
                            }
                        ]
                    ))
                )
            )
        }
    }, [data]);

    useEffect(() => {
        if (businessData?.length > 0)
            setBusiness([
                {component: <BusinessAccordion panels={businessData}/>}
            ])
    }, [businessData]);


    const closeModal = () => {
        setIsAddBusiness((prev) => !prev)
    }


    return (
        <div>
            {isAddBusiness && <AddBusiness closeModal={closeModal}/>}
            <div className={'business'}>
                {!isLoading &&
                business.length === 0 ?
                    <div className="business_empty">
                        <img src={BUSINESS_EMPTY_IMAGE} alt=""/>
                        <h1>No Businesses found</h1>
                        <p>You currently have no business. Please add new business to continue</p>
                        <Button text={'Add Business'} type={'primary'} onclick={() => {
                            setIsAddBusiness((prev) => !prev)
                        }}/>
                    </div>
                    :
                    <div className="business_wrapper">
                        <div className={'business_wrapper_top'}>
                            <h1>Businesses</h1>
                            <Button text={'Add Business'} type={'primary'}
                                    onclick={() => setIsAddBusiness((prev) => !prev)}/>
                        </div>
                        <div className="">
                            {business.map(({component}, index) => <div key={index}>{component}</div>)}
                        </div>
                    </div>
                }
                {isLoading && <div className="business_loading">
                    <div>

                        <img src={BUSINESS_EMPTY_IMAGE} alt=""/>
                        <Loading/>
                    </div>
                </div>}
            </div>
        </div>
    );
};

export default Business;

